import { customFetch } from "../helpers/customFetch";
import { URL_EXACTIAN, getConfigExactian } from "../helpers/helpers";

export const documentsGet = async () => {
    try {
        const configs = getConfigExactian('GET');
        const response = await customFetch(`${URL_EXACTIAN}ws2/exactian/concept/Documents?presentation_type[]=0&presentation_type[]=1&resource_type[]=E`, configs)
        if (!response.ok) {
            return {
                ok: false,
                data: response
            }
        } else {
            const resData = await response.json();
            return {
                ok: true,
                data: resData
            }
        }
    } catch (e) {
        console.log(e);
    }
}